exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listView_aSqOHzxnZfwvyFvTqYj2n {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_listView": "IA_listView_aSqOHzxnZfwvyFvTqYj2n"
};